export const defaultLinkButtonItem = {
  button_text: 'Link button',
  link_type: 'navigation_link',
  navigation_link_id: null,
  webshop_page_id: null,
  manual_url: '',
}
